import React, { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";
import MarketingPreferencesForm from "../MarketingPreferences/MarketingPreferencesForm";
import { AccountContext } from "../../store/AccountContext";

/**
 * PM5 T2 (money path, batch "myaccount-profile") — converted from MUI v4 +
 * `makeStyles` to MUI v5+ (`@mui/material`) `styled`/`sx`.
 * See docs/epics/pm5-mui-v5-migration.md §3 (T2) and docs/mui-conversion-guide.md.
 *
 * Styling-only: no handler, prop, condition or DOM node moved. The child
 * `MarketingPreferencesForm` is still a v4 file and is deliberately untouched
 * (its own tranche) — the dual-runtime bridge is exactly what lets it stay.
 */

// was: useStyles().root — a bare <div>, which has no `sx` prop (guide §1.2).
const ModalBody = styled("div")(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  height: "100%",
  width: "100%",
  boxSizing: "content-box",
}));

const MarketingPreferencesModal = () => {
  const { userProfile } = useContext(AccountContext);
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate("/myaccount/overview");
  }, [navigate]);

  return (
    <Dialog open={true} onClose={handleClose}>
      <ModalBody>
        {userProfile ? (
          <MarketingPreferencesForm
            unsubscribeToken={userProfile.unsubscribeToken}
            embedded={true}
            onClose={handleClose}
          />
        ) : null}
      </ModalBody>
    </Dialog>
  );
};

export default MarketingPreferencesModal;
